import { Component } from '@angular/core';
import { BaseWdxFormControlClass } from '../../../abstract-classes/base-form-control.class';

@Component({
    selector: 'wdx-ff-label-control',
    templateUrl: './form-label-control.component.html',
    standalone: false,
})
export class FormLabelControlComponent extends BaseWdxFormControlClass {}
